import TimetableAdapter from './base';

export default class Structure extends TimetableAdapter {
  modelNamePlural = 'structures';
}
